import React from 'react';
import {
  StyleSheet,
  View,
  Text,
  TouchableOpacity,
  ScrollView,
  Dimensions,
} from 'react-native';
import {colors} from 'src/assets';
import {ReviewCard} from 'src/components';
import {IReview} from 'src/domains';
import LocalText from 'src/local';

export type ReviewCarouselProps = {
  title: string;
  reviews: IReview[];
  onMore: () => void;
};

export const ReviewCarousel: React.FC<ReviewCarouselProps> = ({
  title,
  reviews,
  onMore,
}) => {
  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <Text style={styles.title}>{title}</Text>
        <TouchableOpacity onPress={onMore}>
          <Text style={styles.btn}>
            {LocalText.components.reviewCarousel.showMore}
          </Text>
        </TouchableOpacity>
      </View>
      <ScrollView
        horizontal
        showsHorizontalScrollIndicator={false}
        pagingEnabled>
        {reviews.map(item => (
          <ReviewCard
            key={item.id}
            review={item}
            containerStyle={styles.reviewCard}
            onPress={() => console.log('onReview...')}
          />
        ))}
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'column',
    marginTop: 8,
    paddingVertical: 8,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingHorizontal: 16,
    marginBottom: 16,
  },
  title: {
    flex: 1,
    fontSize: 16,
    fontWeight: 'bold',
  },
  btn: {
    fontSize: 14,
    fontWeight: 'bold',
    color: colors.chokuRed,
  },
  scrollView: {},
  reviewCard: {
    width: Dimensions.get('window').width - 16 * 2,
    marginHorizontal: 16,
  },
});
